<mz-navbar navbarClass="ae-container-fluid ae-container-fluid--full rk-header  white-text">
  <mz-navbar-item-container [align]="'left'">
    <mz-navbar-item><a id="btn-sidenav" class="sidenav-trigger white-text"><i class="material-icons">menu</i></a></mz-navbar-item>
  </mz-navbar-item-container>

  <img class="white-text" 
    style="width: 130px;padding-top: 14px" src="assets/logo-light.png">
  
  <mz-navbar-item-container [align]="'right'">
    <mz-navbar-item [routerLink]="['/alertas']" routerLinkActive="active" (click)="consultarTotalAlertas()" style="cursor: pointer;">
      <i class="material-icons white-text text-lighten-1 notifications-class">notifications </i>
      <div class="div-not-class" *ngIf="totalAlertas == 0" style="margin-right: 50px;"></div>
    <div class="div-not-class" *ngIf="totalAlertas>0">
        <mz-badge [value]="totalAlertas" [badgeClass]="'grey'"></mz-badge>
      </div>
    </mz-navbar-item>
    <mz-navbar-item></mz-navbar-item>
    <mz-navbar-item style="cursor: pointer;">
        <a class="tooltipped " mz-tooltip (click) = "changeEscheme()" [position]="'left'" [html]="true" [tooltip]="'Cambiar de esquema'">
          <i class="material-icons white-text text-lighten-1 tooltipped">swap_horizontal_circle</i>
        </a>
    </mz-navbar-item>
    <mz-navbar-item>{{ esquema }}</mz-navbar-item>
    <mz-navbar-item></mz-navbar-item>
    <mz-navbar-item style="cursor: pointer;"><a class="tooltipped " mz-tooltip [position]="'left'" [html]="true" [tooltip]="rol"><i class="material-icons white-text text-lighten-1 tooltipped">account_circle</i></a></mz-navbar-item>
    <mz-navbar-item> {{ usernameauth }} </mz-navbar-item>
    <mz-navbar-item>
      <a class="tooltipped " mz-tooltip (click)="logout()" [position]="'left'" [html]="true" [tooltip]="'Salir del sistema'">
        <i class="material-icons white-text responsive-img">logout</i>
      </a>
    </mz-navbar-item>
  </mz-navbar-item-container>
</mz-navbar>

<!-- 
    SIDENAV
 -->
<mz-sidenav [id]="'sidenav'" [collapseButtonId]="'btn-sidenav'" [closeOnClick]='true'>
  
  <mz-sidenav-header style="text-align:center;">
      <img src="assets/logo-dark.png" style="width: 191px;margin-top: 28px;">
  </mz-sidenav-header>

  <mz-sidenav-divider></mz-sidenav-divider>

  <!-- EJECUTOR -->
  <div *ngIf="rolauth == 1">
      <mz-sidenav-link *ngIf = "idesquema == 1">
          <a class="left-align font-size-titles" [routerLink]="['/binmanager']" [queryParams]="{ refresh: time }" queryParamsHandling="merge" routerLinkActive="active"><i class="material-icons">business</i>INSUMO BIN MANAGER</a>
      </mz-sidenav-link>
              
      <mz-sidenav-link>
          <a class="left-align font-size-titles" [routerLink]="['/binesAbc']" [queryParams]="{ refresh: time }" queryParamsHandling="merge" routerLinkActive="active"><i class="material-icons">add</i>ALTA BINES</a>
      </mz-sidenav-link>

      <mz-sidenav-link>
          <a  class="font-size-titles" active [routerLink]="['/busquedaEjecutor']" routerLinkActive="active"><i class="material-icons">search</i>BÚSQUEDA DE BIN</a>
      </mz-sidenav-link>

      <mz-sidenav-link>
          <a  class="font-size-titles" active [routerLink]="['/movimientosAutomaticos']" routerLinkActive="active"><i class="material-icons">youtube_searched_for</i>MOVIMIENTOS AUTOMÁTICOS</a>
      </mz-sidenav-link>
              
      <mz-sidenav-link>
          <a class="font-size-titles" [routerLink]="['cifrasControl']" [queryParams]="{ refresh: time }" queryParamsHandling="merge" routerLinkActive="active"><i class="material-icons">equalizer</i>CIFRAS CONTROL</a>
      </mz-sidenav-link>
              
      <mz-sidenav-link>
          <a class="font-size-titles" [routerLink]="['bitacoraMovimien']" [queryParams]="{ refresh: time }" queryParamsHandling="merge" routerLinkActive="active"><i class="material-icons">content_paste</i>BITÁCORA DE MOVIMIENTOS</a>
      </mz-sidenav-link>
  </div>


  <!-- Supervisor -->
  <div *ngIf="rolauth == 2">
      <mz-sidenav-link>
        <a active class="waves-effect font-size-titles" [routerLink]="['checkSupervisor']" routerLinkActive="active"><i class="material-icons">playlist_add_check</i>CHECK DE BIN</a>
      </mz-sidenav-link>

      <mz-sidenav-link>
        <a active class="waves-effect font-size-titles" [routerLink]="['busquedaSupervisor']" routerLinkActive="active"><i class="material-icons">search</i>BÚSQUEDA DE BIN</a>
      </mz-sidenav-link>

      <mz-sidenav-link>
        <a  class="font-size-titles" active [routerLink]="['/movimientosAutomaticos']" routerLinkActive="active"><i class="material-icons">youtube_searched_for</i>MOVIMIENTOS AUTOMÁTICOS</a>
      </mz-sidenav-link>
            
      <mz-sidenav-link>
        <a class="waves-effect font-size-titles" [routerLink]="['cifrasControl']" [queryParams]="{ refresh: time }" queryParamsHandling="merge" routerLinkActive="active"><i class="material-icons">equalizer</i>CIFRAS CONTROL</a>
      </mz-sidenav-link>
            
      <mz-sidenav-link>
        <a class="waves-effect font-size-titles" [routerLink]="['bitacoraMovimien']" [queryParams]="{ refresh: time }" queryParamsHandling="merge" routerLinkActive="active"><i class="material-icons">content_paste</i>BITÁCORA DE MOVIMIENTOS</a>
      </mz-sidenav-link>                        

      <mz-sidenav-link>
        <a class="waves-effect font-size-titles" [routerLink]="['Administracion']" [queryParams]="{ refresh: time }" queryParamsHandling="merge" routerLinkActive="active"><i class="material-icons">dashboard</i>ADMINISTRACIÓN</a>
      </mz-sidenav-link>

      <mz-sidenav-link>
        <a class="waves-effect font-size-titles" class="waves-effect waves-light btn" (click)="abrirModalContingencia()"><i class="material-icons">warning</i>CONTINGENCIA</a>
      </mz-sidenav-link>
 

  </div>


  <!-- Prevencion de fraudes-->
  <div  *ngIf="rolauth == 3">
    <mz-sidenav-link>
      <a  active class="font-size-titles" [routerLink]="['busquedaPrevencion']" routerLinkActive="active"><i class="material-icons">search</i>BÚSQUEDA DE BIN</a>
    </mz-sidenav-link>
  </div>

  <!-- Auditoria -->
  <div *ngIf="rolauth == 4">
      <mz-sidenav-link>
          <a  class="font-size-titles" active [routerLink]="['/movimientosAutomaticos']" routerLinkActive="active"><i class="material-icons">youtube_searched_for</i>MOVIMIENTOS AUTOMÁTICOS</a>
      </mz-sidenav-link>

      <mz-sidenav-link>
          <a  class="font-size-titles" active [routerLink]="['cifrasControl']" routerLinkActive="active"><i class="material-icons">equalizer</i>CIFRAS CONTROL</a>
      </mz-sidenav-link>
              
      <mz-sidenav-link>
          <a  class="font-size-titles" [routerLink]="['bitacoraMovimien']" [queryParams]="{ refresh: time }" queryParamsHandling="merge" routerLinkActive="active"><i class="material-icons">content_paste</i>BITÁCORA DE MOVIMIENTOS</a>
      </mz-sidenav-link>
  </div>

   <!--Administrador-->

<div *ngIf="rolauth == 5">
  <mz-sidenav-link>
    <a class="waves-effect font-size-titles" active [routerLink]="['Administracion']" routerLinkActive="active"><i class="material-icons">dashboard</i>ADMINISTRACIÓN</a>
  </mz-sidenav-link>
  <mz-sidenav-link>
    <a class="waves-effect font-size-titles"  [routerLink]="['Configuracion']" [queryParams]="{ refresh: time }" queryParamsHandling="merge" routerLinkActive="active"><i class="material-icons">settings</i>CONFIGURACIÓN</a>
  </mz-sidenav-link>
</div>

</mz-sidenav>

<mz-modal #bottomSheetModal>
    <mz-modal-header>
      <h4>Mensaje de sistema</h4>
    </mz-modal-header>
    <mz-modal-content>
      ¿Está seguro de iniciar proceso de Contingencia?
    </mz-modal-content>
    <mz-modal-footer>
      <button mz-button [flat]="true" mz-modal-close>CANCELAR</button>
      <button mz-button [flat]="true" (click)="activarContingencia()" mz-modal-close>ACEPTAR</button>
    </mz-modal-footer>
  </mz-modal>